import React, { useState } from 'react';
import { CameraIcon } from '@heroicons/react/24/outline';
import { Tooltip } from '@plerionhq/design-system';
import { takeScreenshot } from '../../../../../utils/screenshotUtils';

interface ScreenshotButtonProps {
  targetRef?: React.RefObject<HTMLElement | null>;
  filename?: string;
  className?: string;
  title?: string;
  dataTestId?: string;
}

export const ScreenshotButton: React.FC<ScreenshotButtonProps> = ({
  targetRef,
  filename = 'screenshot.png',
  className = '',
  title = 'Save as image',
  dataTestId = 'screenshot-button',
}) => {
  const [isCapturing, setIsCapturing] = useState(false);

  const handleScreenshot = async () => {
    if (!targetRef?.current || isCapturing) {
      return;
    }

    setIsCapturing(true);
    try {
      await takeScreenshot(targetRef.current, {
        filename,
        scale: 2,
        backgroundColor: '#ffffff',
      });
    } catch (error) {
      console.error('Failed to take screenshot:', error);
    } finally {
      setIsCapturing(false);
    }
  };

  return (
    <Tooltip label={title} placement="top">
      <button
        onClick={handleScreenshot}
        disabled={isCapturing}
        data-testid={dataTestId}
        className={`rounded-md border border-gray-300 bg-white px-2 py-1.5 text-gray-700 shadow-sm transition-all hover:border-gray-400 hover:bg-gray-50 hover:text-gray-900 hover:shadow-md focus:ring-2 focus:ring-orange-500 focus:ring-offset-1 focus:outline-none disabled:cursor-not-allowed disabled:opacity-50 disabled:hover:border-gray-300 disabled:hover:bg-white disabled:hover:shadow-sm dark:border-gray-600 dark:bg-gray-900 dark:text-gray-300 dark:hover:border-gray-500 dark:hover:bg-gray-800 dark:hover:text-gray-100 ${className}`}
      >
        <CameraIcon className="h-4 w-4" />
      </button>
    </Tooltip>
  );
};
